import { render, staticRenderFns } from "./AssignParcelTrigger.vue?vue&type=template&id=538a6482&"
import script from "./AssignParcelTrigger.vue?vue&type=script&lang=js&"
export * from "./AssignParcelTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports